import CopyText from "../components/copy/CopyText";
import { getReferralRegistrationLink } from "../utils/constants";

const defaultRender = (value) => (value ? value : "--");
const columns = [
  {
    title: "Name",
    dataIndex: "name",
    render: defaultRender,
    // sorter: (a, b) => a?.name?.localeCompare(b?.name),
  },
  {
    title: "Phone No",
    dataIndex: "phoneNo",
    render: defaultRender,
    // sorter: (a, b) => a?.phoneNo?.localeCompare(b?.phoneNo),
  },

  {
    title: "Created At",
    dataIndex: "createdDate",
    render: defaultRender,
    // sorter: (a, b) => ((new Date(a.createdDate)) - (new Date(b.createdDate))),
  },
  {
    title: "Created By",
    dataIndex: "createdBy",
    render: defaultRender,
  },
  {
    title: "Referral Code",
    dataIndex: "referralCode",
    render: (value) =>
      value ? (
        <div className="flex items-center gap-1">
          <p className="mb-0">{value}</p>
          <div onClick={(e) => e.stopPropagation()}>
            <CopyText text={getReferralRegistrationLink(value)} />
          </div>
        </div>
      ) : (
        "--"
      ),
  },
  {
    title: "Department",
    dataIndex: "department",
    render: defaultRender,
  },
  {
    title: "Office",
    dataIndex: "office",
    render: defaultRender,
  },
  {
    title: "Team Leader",
    dataIndex: "teamLeader",
    render: defaultRender,
  },
  {
    title: "Role",
    dataIndex: "roleName",
    render: defaultRender,
  },
  {
    title: "Status",
    dataIndex: "status",
    render: defaultRender,
  },
  {
    title: "Actions",
    dataIndex: "actions",
    render: defaultRender,
  },
];

export default columns;
